module.exports = __webpack_public_path__ + "img/4.79e109b2.png";